module.exports = __webpack_public_path__ + "a17d279f/img/cadBim.e369a02a.png";